import { Box, Image } from '@chakra-ui/react';

import sigliveEmpty from 'Asset/image/siglive-empty-state.svg';
import { dailyLogText } from 'Const/monitoring/view';
import { TextBold, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const EmptyDailyLog = () => {
  return (
    <Box className={styles['daily-log__container']}>
      <Image src={sigliveEmpty} alt="siglive-empty" />
      <Box className={styles['daily-log__empty-text']}>
        <TextBold className={styles['daily-log__empty-title']}>{dailyLogText.emptyTitle}</TextBold>
        <TextRegular className={styles['daily-log__empty-desc']}>{dailyLogText.emptyDescription}</TextRegular>
      </Box>
    </Box>
  );
};

export default EmptyDailyLog;
